import React from 'react'
import { Grid } from '@material-ui/core'
import SocialMediaPageMetricCard from './SocialMediaPageMetricCard.jsx'

const renderSocialMediaMetricCard = ({ type, pageName, likes, comments }) => (
  <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
    <SocialMediaPageMetricCard
      pageName={pageName}
      pageType={type}
      likesCount={likes}
      commentsCount={comments}
    />
  </Grid>
)

const SocialMediaMetricCards = (socialMediaData) => {
  return Object.keys(socialMediaData).map((pageType) => {
    const pages = socialMediaData[pageType]
    return !Array.isArray(pages)
      ? renderSocialMediaMetricCard({ type: pageType, ...pages })
      : pages.map((page) =>
          renderSocialMediaMetricCard({ type: pageType, ...page }),
        )
  })
}

const SocialMediaInteractionsTab = ({ socialMediaTabDetails }) => {
  return (
    <Grid container spacing={2}>
      {SocialMediaMetricCards(socialMediaTabDetails)}
    </Grid>
  )
}

export default SocialMediaInteractionsTab
